module.exports = __webpack_public_path__ + "static/media/1.0f27e74f.jpg";